import { Component, OnInit, AfterViewInit, ViewChild, EventEmitter, ElementRef  } from '@angular/core';
import { NgForm, FormGroup, FormArray, FormControl, Validators, FormBuilder  } from '@angular/forms';
import { PackagesRules } from '../../services/packages-rules.service';
import {DialogSharedComponent} from '../dialog-shared/dialog-shared.component';
import {MatDialog} from '@angular/material';

@Component({
  selector: 'app-packages-rules',
  templateUrl: './packages-rules.component.html',
  providers: [PackagesRules],
  styleUrls: ['./packages-rules.component.scss']
})
export class AdminPackagesRulesComponent implements OnInit, AfterViewInit {

    packagesForm: FormGroup;
    products: any;
    packs: Array<{value: string, label: string}> = [{value: '', label: ''}];
    types: Array<{value: string, label: string}> = [{value: '', label: ''}];
    details: Array<{value: string, label: string}> = [{value: '', label: ''}];
    submittedPackage = false;
    logged = false;
    productNum = 0;
    packDimensions: any;

    @ViewChild('packRule') public packRule: ElementRef;

    constructor(private _fb: FormBuilder, private rules: PackagesRules, public dialog: MatDialog) {}


    ngOnInit() {
        this.packagesForm = this._fb.group({
            products: this._fb.group({
                product: [null, Validators.required]
            }),
            types: this._fb.group({
                type: ['', Validators.required]
            }),
            otherDetails: this._fb.group({
                detail: ['', Validators.required]
            }),
            packageRule: this._fb.group({
                length_min:   ['', Validators.required],
                length_max:   ['', Validators.required],
                length_circum:   [''],
                width_min:   ['', Validators.required],
                width_max:   ['', Validators.required],
                height_min:   ['', Validators.required],
                height_max:   ['', Validators.required],
                weight_min:   ['', Validators.required],
                weight_max:   ['', Validators.required],
                weight_min_ship:   ['', Validators.required],
                weight_max_ship:   ['', Validators.required],
                volume_min:   ['', Validators.required],
                volume_max:   ['', Validators.required],
                volume_min_ship:   ['', Validators.required],
                volume_max_ship:   ['', Validators.required],
                loading_meter_min:   ['', Validators.required],
                loading_meter_max:   ['', Validators.required],
                quantity_min:   ['', Validators.required],
                quantity_max:   ['', Validators.required],
                insurance_min:   [''],
                insurance_max:   [''],
                id:   ['']
            })
        });

        this.packagesForm.controls['products'].valueChanges.subscribe(
            (data: any) => {

              this.change('product');
            }
        );
        this.packagesForm.controls['types'].valueChanges.subscribe(
            (data: any) => this.change('type')
        );
        this.packagesForm.controls['otherDetails'].valueChanges.subscribe(
            (data: any) => this.change('otherDetails')
        );


        this.rules.getPackages().subscribe((data) => {
            this.products = data;
            if (data[0] && typeof(data[0]) !== 'undefined') {
                const getProductData = [];
                let getFirstProduct = '';
                for (const key in data) {    //product
                    getProductData.push({value: key, label: data[key].name});
                    if (getFirstProduct === '') {
                        getFirstProduct = key;
                    }
                }
                this.packs = getProductData;
                this.packDimensions = data[0].packages;
                const checkOtherDetails = [];
                const checkType = [];
                this.types = [];
                this.details = [];
                for (const key in this.packDimensions) {    //dimensions
                    if (checkType.indexOf(this.packDimensions[key].type.id) < 0) {
                        this.types.push({
                            value: this.packDimensions[key].type.id,
                            label: this.packDimensions[key].type.name
                        });
                        checkType.push(this.packDimensions[key].type.id);
                    }
                    if (this.packDimensions[key].type.name === this.packDimensions[0].type.name && checkOtherDetails.indexOf(this.packDimensions[key].other_details) < 0) {// check all same types and getting //all details for that selected type
                        let other_details = 'None';
                        if (this.packDimensions[key].other_details !== 0) {
                            other_details = this.packDimensions[key].other_details;
                        }
                        checkOtherDetails.push(other_details);
                        this.details.push({value: key, label: other_details});
                    }
                }

                this.logged = true;
                if (getFirstProduct !== '') {
                    // this.packagesForm.controls['products']['controls'].product.setValue(getFirstProduct);
                }
                this.addPackRules();
            }
        });
    }

    ngAfterViewInit() {
        /*if (typeof (this.packRule) != 'undefined') {
            let all = this.packRule.nativeElement.getElementsByClassName('dim-pack');)
            for (let i=0; i < all.length; i++){
                all[i].focus();     all[i].checked = true;    all[i].click();  all[i].touchAction = true;    }
        }*/
    }

    addPackRules() {
        const dim = this.packagesForm.controls['packageRule'];
        const pack = this.products[this.productNum]['packages'];
        const type = this.packagesForm.controls['types'].value.type;
        const otherDetails = this.packagesForm.controls['otherDetails'].value.detail;
        for (const key in pack) {
            if (pack[key].type.id === type && pack[key].other_details === pack[otherDetails].other_details) {
                dim['controls'].length_min.setValue(Number(pack[key].length_min) + 0);
                dim['controls'].length_max.setValue(Number(pack[key].length_max) + 0);
                dim['controls'].width_min.setValue(Number(pack[key].width_min) + 0);
                dim['controls'].width_max.setValue(Number(pack[key].width_max) + 0);
                dim['controls'].height_min.setValue(Number(pack[key].height_min) + 0);
                dim['controls'].height_max.setValue(Number(pack[key].height_max) + 0);
                dim['controls'].weight_min.setValue(Number(pack[key].weight_min) + 0);
                dim['controls'].weight_max.setValue(Number(pack[key].weight_max) + 0);
                dim['controls'].weight_min_ship.setValue(Number(pack[key].weight_min_ship) + 0);
                dim['controls'].weight_max_ship.setValue(Number(pack[key].weight_max_ship) + 0);
                dim['controls'].volume_min.setValue(Number(pack[key].volume_min) + 0);
                dim['controls'].volume_max.setValue(Number(pack[key].volume_max) + 0);
                dim['controls'].volume_min_ship.setValue(Number(pack[key].volume_min_ship) + 0);
                dim['controls'].volume_max_ship.setValue(Number(pack[key].volume_max_ship) + 0);
                dim['controls'].loading_meter_min.setValue(Number(pack[key].loading_meter_min) + 0);
                dim['controls'].loading_meter_max.setValue(Number(pack[key].loading_meter_max) + 0);
                dim['controls'].quantity_min.setValue(Number(pack[key].quantity_min) + 0);
                dim['controls'].quantity_max.setValue(Number(pack[key].quantity_max) + 0);
                dim['controls'].insurance_min.setValue(Number(pack[key].insurance_min) + 0);
                dim['controls'].insurance_max.setValue(Number(pack[key].insurance_max) + 0);
                dim['controls'].length_circum.setValue(Number(pack[key].length_circum) + 0);
                dim['controls'].id.setValue(pack[key].id);
            }
        }
    }

    change(select) {
        this.productNum = this.packagesForm.controls['products'].value.product;
        if (!this.productNum) {
          return;
        }
        this.packDimensions = this.products[this.productNum].packages;
        const checkOtherDetails = [];
        const checkType = [];
        if (select === 'product') {
            this.types = [];
        }
        if (select === 'product' || select === 'type') {
            this.details = [];
        }
        let typesSet = false;
        for (const key in this.packDimensions) {    //dimensions
            if (checkType.indexOf(this.packDimensions[key].type.id) < 0 && select === 'product') {
                this.types.push({value: this.packDimensions[key].type.id.toString(), label: this.packDimensions[key].type.name});
                checkType.push(this.packDimensions[key].type.id);
                if (!typesSet) {
                    typesSet = true;
                    this.packagesForm.controls['types']['controls'].type.setValue(this.packDimensions[key].type.id.toString());
                }

            }
            if (this.packDimensions[key].type.name === this.packDimensions[0].type.name
                && checkOtherDetails.indexOf(this.packDimensions[key].other_details) < 0 && select === 'type') {
                let other_details = 'None';
                if (this.packDimensions[key].other_details !== 0) {
                    other_details = this.packDimensions[key].other_details;
                }
                checkOtherDetails.push(other_details);
                this.details.push({value: key, label: other_details});
            }
        }
        if (select === 'product' || select === 'type') {
            this.packagesForm.controls['otherDetails']['controls'].detail.setValue('0');
        }
        this.submittedPackage = false;
        this.addPackRules();
    }

   save() {
       this.submittedPackage = true;
       if (this.packagesForm.valid) {
           const id = this.packagesForm.controls['packageRule']['controls'].id.value;
           const controls = this.packagesForm.controls['packageRule'];

           const data = {
               length_min:   controls['controls'].length_min.value,
               length_max:   controls['controls'].length_max.value,
               length_circum:   controls['controls'].length_circum.value,
               width_min:   controls['controls'].width_min.value,
               width_max:   controls['controls'].width_max.value,
               height_min:   controls['controls'].height_min.value,
               height_max:   controls['controls'].height_max.value,
               weight_min:   controls['controls'].weight_min.value,
               weight_max:   controls['controls'].weight_max.value,
               weight_min_ship:   controls['controls'].weight_min_ship.value,
               weight_max_ship:   controls['controls'].weight_max_ship.value,
               volume_min:   controls['controls'].volume_min.value,
               volume_max:   controls['controls'].volume_max.value,
               volume_min_ship:   controls['controls'].volume_min_ship.value,
               volume_max_ship:   controls['controls'].volume_max_ship.value,
               loading_meter_min:   controls['controls'].loading_meter_min.value,
               loading_meter_max:   controls['controls'].loading_meter_max.value,
               quantity_min:   controls['controls'].quantity_min.value,
               quantity_max:   controls['controls'].quantity_max.value,
               insurance_min:   controls['controls'].insurance_min.value,
               insurance_max:   controls['controls'].insurance_max.value
           };

           this.rules.setPackage(id, data).subscribe((data) => {
             const dialogRef = this.dialog.open(DialogSharedComponent,
               {width: '450px', data: { errorType: 'null', header: 'service.success' }});
           });
       } else {
         const dialogRef = this.dialog.open(DialogSharedComponent,
           {width: '450px', data: { errorType: 'null', header: 'service.fieldsMustBeFilled' }});
       }
       return false;
   }
}



// WEBPACK FOOTER //
// ./src/app/components/packages-rules/packages-rules.component.ts